module.exports = __webpack_public_path__ + "img/downloadStatement.a7892339.svg";